<template>
  <div class="archive-sub-nav">
    <ul>
      <li v-for="route in routes" :key="route.id">
        <router-link :to="{ path: route.routePath }">
          {{ route.routeName }}
        </router-link>
      </li>
    </ul>
    <span v-if="subText.length">{{ subText }}</span>
  </div>
</template>
<script>
export default {
  name: 'ArchiveSubNav',
  props: {
    routes: {
      type: Array,
      required: true,
      default: () => []
    },
    subText: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_archive-sub-nav.scss';
</style>
